module.exports = __webpack_public_path__ + "img/logotipo-normal_dark.ab01aeac.png";